'use client';
import React, { forwardRef, useState, useCallback } from 'react';
import styles from './Timeline.module.css.js';
import { format } from 'date-fns';

const Timeline = ({ items, offset = 0, grayOutCompleted = false, style }) => {
    const [progressHeight, setProgressHeight] = useState(0);
    const lastCompletedIndex = items.findLastIndex(item => item.completed);
    if (progressHeight !== '100%' && lastCompletedIndex === items.length - 1) {
        setProgressHeight('100%');
    }
    const onRefChange = useCallback(node => {
        if (node === null) ;
        else {
            setProgressHeight(node.offsetTop + 15);
            // DOM node referenced by ref has changed and exists
        }
    }, []); // adjust deps
    return (React.createElement("ul", { style: style, className: styles.timelineList },
        React.createElement("div", { className: styles.bar },
            React.createElement("div", { style: { height: typeof progressHeight === 'string' ? progressHeight : progressHeight + offset }, className: styles.innerBar })),
        items.map((item, index) => {
            const ref = (index - 1 === lastCompletedIndex) ? onRefChange : undefined;
            return React.createElement(TimelineItem, { grayOutCompleted: grayOutCompleted, key: item.id, ref: ref, completed: item.completed, size: item.size, date: item.date, title: item.header }, item.content);
        })));
};
const TimelineItem = forwardRef(({ completed = false, children, title, date, size = 2, grayOutCompleted }, forwardedRef) => {
    const fontSize = (size + 2) * 8;
    const shouldGray = completed && grayOutCompleted;
    return (React.createElement(React.Fragment, null,
        React.createElement("dt", { "data-gray": shouldGray, ref: forwardedRef, style: { fontSize }, className: styles.dt },
            React.createElement("sub", { className: styles.label }, date ? format(date, 'MMM d') : 'TBD'),
            React.createElement("div", { className: styles.circleWrapper },
                React.createElement("div", { "data-completed": completed, className: styles.circle })),
            title),
        React.createElement("dd", { "data-gray": shouldGray, style: { fontSize: fontSize * 0.8 }, className: styles.dd }, children)));
});

export { Timeline };
